<template>
  <div>
    <transition name="el-fade-in-linear">
      <div class="updateUser" v-show="updateInfoStatus">
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules2"
          ref="ruleForm"
          class="signup_ruleForm"
        >
          <i class="el-icon-close" @click="close"></i>
          <h3 class="add">{{ $t('message.updateInformation') }}</h3>
          <el-form-item :label="$t('user.Email')" prop="email">
            <el-input
              type="email"
              v-model="ruleForm.email"
              autocomplete="off"
              placeholder="Email"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('user.FirstName')" prop="firstName">
            <el-input
              type="text"
              v-model="ruleForm.firstName"
              autocomplete="off"
              placeholder="First Name"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('user.LastName')" prop="lastName">
            <el-input
              type="text"
              v-model="ruleForm.lastName"
              autocomplete="off"
              placeholder="Last Name"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('user.Title')" prop="title">
            <el-input
              type="text"
              v-model="ruleForm.title"
              autocomplete="off"
              placeholder="Title"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('user.Company')" prop="company">
            <el-input
              type="text"
              v-model="ruleForm.company"
              autocomplete="off"
              placeholder="Company"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm2('ruleForm')"
              ><i class="el-icon-loading" v-if="loading"></i>{{ $t('message.update') }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios'
import { Message } from 'element-ui'
import VueRouter from 'vue-router'

const { isNavigationFailure, NavigationFailureType } = VueRouter

export default {
  name: 'updateUser',
  user: {},
  props: {
    updateInfoStatus: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      ruleForm: {
        firstName: '',
        lastName: '',
        email: '',
        title: '',
        company: ''
      },
      rules2: {
        firstName: [{ required: true, message: this.$t('errMsg.firstNameErr'), trigger: 'blur' }],
        lastName: [{ required: true, message: this.$t('errMsg.lastNameErr'), trigger: 'blur' }],
        title: [{ required: true, message: this.$t('errMsg.titleErr'), trigger: 'blur' }],
        company: [{ required: true, message: this.$t('errMsg.companyErr'), trigger: 'blur' }]
      }
    }
  },
  methods: {
    submitForm2(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true
          let data = {
            firstName: this.ruleForm.firstName,
            lastName: this.ruleForm.lastName,
            password: this.ruleForm.pass,
            oldPassword: this.ruleForm.oldPass,
            title: this.ruleForm.title,
            company: this.ruleForm.company
          }
          axios
            .post(`/api/user/${this.ruleForm.email}`, data)
            .then(response => {
              this.loading = false
              Message({
                type: 'success',
                message: this.$t('message.updateSuccessfully'),
                showClose: true
              })
              this.close()
              this.$emit('updateUser')
            })
            .catch(err => {
              this.loading = false
              Message({
                type: 'error',
                message: err.response.data.statusCode + ' ' + err.response.data.message,
                showClose: true
              })
            })
          this.$refs[formName].clearValidate()
        } else {
          Message({ type: 'error', message: this.$t('errMsg.err1'), showClose: true })
          return false
        }
      })
    },
    close() {
      this.$emit('close2')
    },
    getUser() {
      axios
        .get('/api/user')
        .then(res => {
          this.user = res.data
          this.ruleForm.firstName = this.user.firstName
          this.ruleForm.lastName = this.user.lastName
          this.ruleForm.email = this.user.email
          this.ruleForm.title = this.user.title
          this.ruleForm.company = this.user.company
        })
        .catch(err => {
          this.$router.push('/login').catch(err => {
            // to hide the below error message
            if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
              throw Error(err)
            }
          })
        })
    }
  },
  created() {
    this.getUser()
  },
  mounted() {
    let self = this
    this.$nextTick(function() {
      document.addEventListener('keyup', function(e) {
        if (e.keyCode == 27) {
          self.close()
        }
      })
    })
  }
}
</script>

<style lang="scss" scoped>
.updateUser {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1999;
  @include flex-center;
  .add {
    font-size: 22px;
    font-weight: 900;
    margin-bottom: 15px;
  }
  ::v-deep .el-form-item.is-required .el-form-item__label:before {
    content: '';
  }
  ::v-deep .el-form {
    width: 84vw;
    max-width: 500px;
    max-height: 80vh;
    border: 1px solid #eee;
    background: $white;
    @include border-radius(8px);
    box-sizing: border-box;
    padding: 30px;
    overflow-y: auto;
    position: relative;
    .el-form-item {
      box-sizing: border-box;
      height: 70px;
    }
    .el-icon-close {
      font-size: 18px;
      cursor: pointer;
      @include absolute-right-top(30px, 40px);
    }
  }

  ::v-deep .el-icon-loading {
    margin-right: 5px;
  }

  ::v-deep .el-button--primary {
    width: 100%;
    height: 52px;
    color: $white;
    background-color: $primary-color;
    border: none;
    text-align: center;
    line-height: 52px;
    @include border-radius(28px);
    padding: 0;
    font-size: 19px;
    font-weight: 900;
    margin: 20px auto 0;
    display: block;
  }
}

@media screen and (max-width: 450px) {
  ::v-deep .el-form {
    padding: 30px 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/settings/updateUser.vue